var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.82457 4.87752L8.82458 4.87752C9.03676 4.66526 9.03677 4.32129 8.82457 4.1091L8.82456 4.10909C8.61238 3.89697 8.26834 3.89696 8.05621 4.1091L5.80923 6.35607L5.20673 5.75357L5.20672 5.75356C4.99454 5.54145 4.6505 5.54144 4.43837 5.75357L4.43836 5.75357C4.22618 5.96583 4.22617 6.3098 4.43837 6.522L5.42505 7.50868C5.53111 7.61474 5.67029 7.66778 5.80923 7.66778C5.94817 7.66778 6.08735 7.61474 6.19341 7.50868L8.82457 4.87752Z",
    fill: "#77A251",
    stroke: "#77A251",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 31V23.5H24M16.3333 31H1V1H24V23.5M16.3333 31L24 23.5",
    stroke: "#77A251",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83599 6.35219H19.2942C19.5942 6.35219 19.8375 6.10899 19.8375 5.80885C19.8375 5.50871 19.5942 5.26551 19.2942 5.26551H9.83599C9.53593 5.26551 9.29265 5.50871 9.29265 5.80885C9.29265 6.10899 9.53593 6.35219 9.83599 6.35219Z",
    fill: "#77A251",
    stroke: "#77A251",
    strokeWidth: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55504 10.4134C8.55504 10.7135 8.79832 10.9567 9.09838 10.9567H19.2941C19.5942 10.9567 19.8375 10.7135 19.8375 10.4134C19.8375 10.1132 19.5942 9.87003 19.2941 9.87003H9.09838C8.79832 9.87003 8.55504 10.1132 8.55504 10.4134Z",
    fill: "#77A251",
    stroke: "#77A251",
    strokeWidth: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1245 8.55446H4.49334C4.19328 8.55446 3.95 8.79766 3.95 9.0978V11.729C3.95 12.0291 4.19328 12.2723 4.49334 12.2723H7.1245C7.42457 12.2723 7.66784 12.0291 7.66784 11.729V9.0978C7.66784 8.79766 7.42457 8.55446 7.1245 8.55446ZM6.58116 11.1856H5.03668V9.64115H6.58116V11.1856Z",
    fill: "#77A251",
    stroke: "#77A251",
    strokeWidth: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2941 14.4746H9.09838C8.79832 14.4746 8.55504 14.7178 8.55504 15.0179C8.55504 15.318 8.79832 15.5613 9.09838 15.5613H19.2941C19.5942 15.5613 19.8375 15.318 19.8375 15.0179C19.8375 14.7178 19.5942 14.4746 19.2941 14.4746Z",
    fill: "#77A251",
    stroke: "#77A251",
    strokeWidth: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1245 13.159H4.49334C4.19328 13.159 3.95 13.4022 3.95 13.7023V16.3335C3.95 16.6336 4.19328 16.8768 4.49334 16.8768H7.1245C7.42457 16.8768 7.66784 16.6336 7.66784 16.3335V13.7023C7.66784 13.4022 7.42457 13.159 7.1245 13.159ZM6.58116 15.7901H5.03668V14.2456H6.58116V15.7901Z",
    fill: "#77A251",
    stroke: "#77A251",
    strokeWidth: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2941 19.0791H9.09838C8.79832 19.0791 8.55504 19.3223 8.55504 19.6224C8.55504 19.9226 8.79832 20.1658 9.09838 20.1658H19.2941C19.5942 20.1658 19.8375 19.9226 19.8375 19.6224C19.8375 19.3223 19.5942 19.0791 19.2941 19.0791Z",
    fill: "#77A251",
    stroke: "#77A251",
    strokeWidth: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1245 17.7635H4.49334C4.19328 17.7635 3.95 18.0067 3.95 18.3068V20.938C3.95 21.2381 4.19328 21.4813 4.49334 21.4813H7.1245C7.42457 21.4813 7.66784 21.2381 7.66784 20.938V18.3068C7.66784 18.0067 7.42457 17.7635 7.1245 17.7635ZM6.58116 20.3947H5.03668V18.8502H6.58116V20.3947Z",
    fill: "#77A251",
    stroke: "#77A251",
    strokeWidth: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0929 23.6836H9.02718C8.75941 23.6836 8.55504 23.9344 8.55504 24.227C8.55504 24.5195 8.75941 24.7703 9.02718 24.7703H14.0929C14.3607 24.7703 14.565 24.5195 14.565 24.227C14.565 23.9344 14.3607 23.6836 14.0929 23.6836Z",
    fill: "#77A251",
    stroke: "#77A251",
    strokeWidth: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1245 22.368H4.49334C4.19328 22.368 3.95 22.6112 3.95 22.9114V25.5425C3.95 25.8427 4.19328 26.0859 4.49334 26.0859H7.1245C7.42457 26.0859 7.66784 25.8427 7.66784 25.5425V22.9114C7.66784 22.6112 7.42457 22.368 7.1245 22.368ZM6.58116 24.9992H5.03668V23.4547H6.58116V24.9992Z",
    fill: "#77A251",
    stroke: "#77A251",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrace);
export default __webpack_public_path__ + "static/media/trace.3bc773f852c4a33da0857bd02809740d.svg";
export { ForwardRef as ReactComponent };